import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { segmentsListActions, bcActions } from 'src/store/actions';
import { SegmentsViewWrapper } from 'src/components';
import { GraphicPage } from 'src/containers';

import CONSTANTS from 'src/store/constants';

const FACTORS = 5;
const FACETS = 30;

function ViewSegments({
  match: {
    params: { segmentId: segmentIdParam },
  },
  app: { tenant },
  segmentsView: { segments, fetchSegmentsStatus },
  fetchSegments,
  setDatasetId,
  setSegmentId,
  setDatasetName,
  setSegmentName,
}) {
  const getData = useCallback(() => {
    const query = {
      filters: [
        {
          and: [{ name: 'id', op: 'eq', val: segmentIdParam }],
        },
      ],
    };
    fetchSegments(query);
  }, [fetchSegments, segmentIdParam]);

  const hasData =
    segments &&
    segments.length > 0 &&
    segments[0] &&
    segments[0].pxScores &&
    segments[0].pxScores.length >= FACTORS + FACETS;

  /**
   * Once data is loaded, set breadcrumb details
   */
  useEffect(() => {
    if (segments && segments.length > 0 && fetchSegmentsStatus === CONSTANTS.API.SUCCEEDED) {
      setDatasetId(segments[0].dataset.id);
      setDatasetName(segments[0].dataset.name);
      if (segments[0].filter !== 'POPULATION_SNAPSHOT') {
        setSegmentId(segments[0].id);
        setSegmentName(segments[0].name);
      } else {
        setSegmentId(undefined);
        setSegmentName(undefined);
      }
    }
  }, [segments, fetchSegmentsStatus, setDatasetId, setDatasetName, setSegmentId, setSegmentName]);

  /*
   * Fetch data whenever the tenant or params change
   */
  useEffect(() => {
    if (tenant) {
      getData();
    }
  }, [tenant, segmentIdParam, getData]);

  const data = segments.map(({ pxScores, ...rest }) => ({
    ...rest,
    pxScores: pxScores.filter(({ trait: { subType } }) => subType !== 'factor'),
  }));

  return (
    <SegmentsViewWrapper
      heading="Facets Explorer"
      getData={getData}
      hasData={hasData}
      data={data}
      apiStatus={fetchSegmentsStatus}
    />
  );
}

const mapStateToProps = ({ app, bc, segmentsView }) => ({
  app,
  bc,
  segmentsView,
});

const mapDispatchToProps = (dispatch) => ({
  setDatasetId: (datasetId) => dispatch(bcActions.setDatasetId(datasetId)),
  setDatasetName: (datasetName) => dispatch(bcActions.setDatasetName(datasetName)),
  setSegmentId: (segmentId) => dispatch(bcActions.setSegmentId(segmentId)),
  setSegmentName: (segmentName) => dispatch(bcActions.setSegmentName(segmentName)),
  fetchSegments: (query) => dispatch(segmentsListActions.fetchSegments(query)),
});

ViewSegments.propTypes = {
  app: PropTypes.shape({
    tenant: PropTypes.string.isRequired,
  }).isRequired,
  segmentsView: PropTypes.shape({
    segments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        pxScores: PropTypes.arrayOf(PropTypes.shape({})),
        dataset: PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        }),
        filter: PropTypes.string,
      })
    ).isRequired,
    fetchSegmentsStatus: PropTypes.oneOf([PropTypes.string, null]).isRequired,
  }).isRequired,
  fetchSegments: PropTypes.func.isRequired,
  setDatasetId: PropTypes.func.isRequired,
  setDatasetName: PropTypes.func.isRequired,
  setSegmentId: PropTypes.func.isRequired,
  setSegmentName: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(GraphicPage(ViewSegments));
